import 'core-js/stable';
// Polyfill for string and array includes
import 'core-js/features/array/includes';
import 'core-js/features/string/includes';
import 'core-js/features/string/starts-with';
// Polyfill for is, which is used by react but doesn't work natively in IE
// import 'core-js/features/is';
import 'core-js/features/map';
import 'core-js/features/set';
// Object polyfills
import 'core-js/features/object/assign';
import 'core-js/features/object/values';
import 'core-js/features/object/from-entries';
// For allowing "async/await"
// Polyfill for window.fetch: https://github.com/github/fetch
import 'whatwg-fetch';

// eslint-disable-next-line import/no-unresolved
import { enableMapSet, enablePatches } from 'immer';
// Polyfill for smooth scrolling in Safari & iOS
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

import 'regenerator-runtime/runtime';

// Immer polyfill for older browsers
enablePatches();
enableMapSet();
